module.exports = __webpack_public_path__ + "img/Onboarding.5d983f40.svg";